
export default class VwPickingForDeliveryByDeliveryInstructionFilter {
	

	constructor(){

	/*APP_FILTER_DEFINITION*/
			this.deliveryQualityInspectionStatusCodeEquals = [];
			this.deliveryInstructionNumber = '';
			this.exactType = {
				/*APP_APP_FILTER_CRITERIA*/
				deliveryInstructionNumber: '0',
				deliveryQualityInspectionStatusCodeEquals: '0',
				/*END_APP_FILTER_CRITERIA*/
			};
            
	/*END_APP_FILTER_DEFINITION*/
	}

	

}